import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "../components/Header.js";
import Footer from "../components/Footer.js";
import { scrollToHash } from "../utils/scrollUtils.js";
import { careerForms } from "../data/careerForms.js";

export default function CareerPage() {
  const location = useLocation();

  useEffect(() => {
    scrollToHash(location.hash);
  }, [location.hash]);

  const handleApplyClick = () => {
    const subject = "Job Application - Message Therapist";
    const body = `Dear Barma Sorig Team,

I am interested in applying for the Message Therapist position.

Please find my details below:

Name:
Phone:
Experience:

Thank you for your consideration.

Best regards
**_Please attach your resume and any relevant certifications. (Delete this line before submitting)_**
`;

    const mailtoUrl = `mailto:barmasorig2018@gmail.com?subject=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(body)}`;
    window.location.href = mailtoUrl;
  };

  return (
    <>
      <Header />
      <main className="bg-gradient-to-br from-gray-50 via-blue-50 to-white min-h-screen">
        {/* Hero Section */}
        <section className="hero relative bg-gradient-to-br from-amber-800 via-amber-900 to-red-900 text-white py-12 overflow-hidden">
          <div className="absolute top-0 right-0 w-80 h-80 bg-gradient-to-bl from-amber-200/20 to-yellow-300/10 rounded-full blur-2xl translate-x-1/3 -translate-y-1/3"></div>
          <div className="absolute bottom-0 left-0 w-80 h-80 bg-gradient-to-tr from-orange-200/20 to-red-300/10 rounded-full blur-2xl -translate-x-1/3 translate-y-1/3"></div>
          <div className="container mx-auto px-6 text-center relative z-10">
            <h1 className="text-6xl md:text-7xl font-bold mb-6 text-transparent bg-clip-text bg-gradient-to-r from-white via-amber-100 to-yellow-200 drop-shadow-2xl animate-fade-in">
              Career Opportunities
            </h1>
            <p className="text-xl md:text-2xl max-w-3xl mx-auto leading-relaxed text-amber-100 font-light animate-fade-in delay-300">
              Discover short term courses, membership benefits, current
              vacancies, and essential forms for your career journey.
            </p>
          </div>
        </section>
        {/* All Sections in Single Column */}
        <section className="container mx-auto px-4 py-16 max-w-3xl">
          {/* Short Term Course */}
          <section
            id="Short_Term_Course"
            className="bg-white rounded-2xl shadow-lg p-8 border border-sky-100 mb-10"
          >
            <h2 className="text-2xl font-bold text-sky-700 mb-4">
              Short Term Course
            </h2>
            <p className="text-gray-700 text-lg leading-relaxed">
              In this course you will learning the knowledge of traditional
              Ku-Nye therapy. You will be taught to do massage full body parts
              within the significant pressure points. Course is conducted during
              weekdays: three hours a day. (From 9AM-1PM)
            </p>

            <h2 className="text-2xl font-bold text-sky-700 mb-4 mt-4">
              Intensive Course
            </h2>
            <p className="text-gray-700 text-lg leading-relaxed">
              In this intensive course you will be learning the knowledge of
              traditional Ku-Nye therapy. Classes are conducted for three-month
              full days. Contents taught in the intensive Course is the same as
              Full Course. It suits individuals who are busy and eager to learn
              Ku-Nye within short period of time.
            </p>
          </section>

          {/* Membership */}
          <section
            id="Membership"
            className="bg-white rounded-2xl shadow-lg p-8 border border-sky-100 mb-10"
          >
            <h2 className="text-2xl font-bold text-sky-700 mb-4">Membership</h2>
            <p className="text-gray-700 text-lg leading-relaxed mb-4">
              Become a member and enjoy exclusive benefits, updates, and access
              to special events. Lorem ipsum dolor sit amet, consectetur
              adipiscing elit. Vivamus euismod, nisi eu consectetur cursus, nisl
              erat facilisis enim.
            </p>
          </section>
          {/* Vacancy */}
          <section
            id="Vacancy"
            className="bg-white rounded-2xl shadow-lg p-8 border border-sky-100 mb-10"
          >
            <h2 className="text-2xl font-bold text-sky-700 mb-4">Vacancy</h2>
            <p className="text-gray-700 text-lg leading-relaxed">
              Current available vacancy
            </p>
            <ul>
              <li className="mt-2 text-gray-700 flex justify-between items-center">
                Message Therapist - 4 slots
                <button
                  onClick={handleApplyClick}
                  className="inline-block ml-2 px-4 py-1 bg-sky-600 text-white rounded-lg shadow hover:bg-amber-700 transition"
                >
                  Apply Now
                </button>
              </li>
            </ul>
          </section>
          {/* Downloads */}
          <section
            id="downloads"
            className="bg-white rounded-2xl shadow-lg p-8 border border-sky-100"
          >
            <h2 className="text-2xl font-bold text-sky-700 mb-4">Downloads</h2>
            <p className="text-gray-700 mb-4">
              These are the forms you can upload in the Download Menu:
            </p>
            <ul className="space-y-4">
              {careerForms.map((form, idx) => (
                <li
                  key={form.name}
                  className="flex items-center justify-between bg-sky-50 rounded-lg px-4 py-3 shadow hover:bg-sky-100 transition"
                >
                  <span className="text-sky-800 font-medium">
                    {idx + 1}. {form.name}
                  </span>
                  <a
                    href={form.url}
                    download
                    className="inline-flex items-center px-4 py-2 bg-sky-600 text-white rounded-lg font-semibold shadow hover:bg-amber-700 transition"
                    target="__blank"
                  >
                    <i className="fas fa-download mr-2"></i>
                    Download
                  </a>
                </li>
              ))}
            </ul>
          </section>
        </section>
      </main>
      <Footer />
      <style jsx>{`
        @keyframes fade-in {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .animate-fade-in {
          animation: fade-in 0.8s ease-out forwards;
        }
        .delay-300 {
          animation-delay: 0.3s;
        }
      `}</style>
    </>
  );
}
